// src/pages/wizard/StepIndicator.jsx
import React from 'react';
import { Check } from 'lucide-react';

export default function StepIndicator({ steps, currentStep }) {
  return (
    <div className="flex items-center justify-between">
      {steps.map((step, index) => {
        const isCompleted = step.number < currentStep;
        const isCurrent = step.number === currentStep;
        const isUpcoming = step.number > currentStep;

        return (
          <React.Fragment key={step.number}>
            {/* Step */}
            <div className="flex flex-col items-center gap-2 flex-1">
              {/* Circle */}
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all
                  ${isCompleted
                    ? 'bg-blue-500 border-blue-500'
                    : isCurrent
                    ? 'bg-blue-500/10 border-blue-500'
                    : 'bg-[#1a1a1a] border-[#2a2a2a]'
                  }
                `}
              >
                {isCompleted ? (
                  <Check className="w-5 h-5 text-white" />
                ) : (
                  <span
                    className={`text-sm font-medium ${
                      isCurrent ? 'text-blue-500' : 'text-[#6a6a6a]'
                    }`}
                  >
                    {step.number}
                  </span>
                )}
              </div>

              {/* Title */}
              <span
                className={`text-xs font-medium text-center ${
                  isCurrent ? 'text-white' : isCompleted ? 'text-[#a0a0a0]' : 'text-[#6a6a6a]'
                }`}
              >
                {step.title}
              </span>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div
                className={`h-0.5 flex-1 mx-2 transition-all ${
                  step.number < currentStep ? 'bg-blue-500' : 'bg-[#2a2a2a]'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}